import cn from 'classnames/bind';
import React, { FunctionComponent } from 'react';

import { TextProps, TextWeight, TextSize, TextSpacing, TextTag, Theme } from './Text.types';
import styles from './Text.module.css';

const cx = cn.bind(styles);

export const Text: FunctionComponent<TextProps> = (props) => {
    const {
        children,
        className,
        tag = TextTag.P,
        size = TextSize.Body,
        weight = TextWeight.Regular,
        spacing = TextSpacing.Default,
        theme = Theme.Light,
        viewVariant,
        'data-test-id': dataTestId,
    } = props;

    const classList = cx(
        'root',
        `root_size_${size}`,
        `root_weight_${weight}`,
        `root_spacing_${spacing}`,
        `root_theme_${theme}`,
        viewVariant === 'centered' && 'root_centered',
        className
    );

    const elementProps = {
        className: classList,
        'data-test-id': dataTestId,
    };

    switch (tag) {
        case TextTag.H1:
            return <h1 {...elementProps}>{children}</h1>;
        case TextTag.H2:
            return <h2 {...elementProps}>{children}</h2>;
        case TextTag.H3:
            return <h3 {...elementProps}>{children}</h3>;
        case TextTag.H4:
            return <h4 {...elementProps}>{children}</h4>;
        case TextTag.H5:
            return <h5 {...elementProps}>{children}</h5>;
        case TextTag.H6:
            return <h6 {...elementProps}>{children}</h6>;
        case TextTag.Span:
            return <span {...elementProps}>{children}</span>;
        case TextTag.Div:
            return <div {...elementProps}>{children}</div>;
        case TextTag.P:
        default:
            return <p {...elementProps}>{children}</p>;
    }
};

export default Text;
